<template>
    <multiselect class="form-control">
        <template slot="singleLabel" class="signle-lable" slot-scope="props">
            <div class="label">
                <span>{{ props.option }}</span>
            </div>
        </template>
        <template slot="caret">
            <div class="caret">
                <i class="icon icon-chevron-down"></i>
            </div>
        </template>
        <template slot="placeholder" slot-scope="props">
            <div class="placeholder">
                <span>{{ placeholder }}</span>
            </div>
        </template>
    </multiselect>
</template>

<script>
export default {
    props: ['placeholder']
}
</script>

<style>

</style>